<template>
  <my-modal>
    <div class="profile-activity">
      <h2>Прогресс</h2>
      <div class="profile-activity__info">
        <div
          class="profile-activity__chart"
          :class="profileData.sex"
        >
          <div class="profile-activity__chart-percent" v-html="`${options.percentFill}%`" />
          <Doughnut
            ref="chart"
            :width="options.size"
            :height="options.size"
            :options="options"
          />
        </div>
        <div class="profile-activity__achievements">
          <div class="profile-activity__info-person" v-html="profileName" />
          <div class="profile-activity__achievements-read">
            Прочитано материалов: {{stats.finishesCnt}}/{{stats.materialsCnt}}
          </div>
<!--          <div class="profile-activity__achievements-participation">-->
<!--            Участие в конкурсах: {{stats.materialsCnt}}-->
<!--          </div>-->
        </div>
      </div>
      <div class="profile-activity__events">
        <div class="profile-activity__event">
          <div class="profile-activity__event-name">Материалы</div>
          <div class="profile-activity__event-status">Статус</div>
        </div>
<!--        <vue-scrollbar classes="my-scrollbar" ref="Scrollbar">
          <div class="profile-activity__scrollbar">
              <div
                class="profile-activity__event"
                v-for="(eventItem, idx) in events"
                :key="idx"
              >
                <div
                  class="profile-activity__event-name"
                  v-html="eventItem.name"
                />
                <component
                  :is="eventItem.link || eventItem.status === 'possible' ? 'a' : 'div'"
                  :href="eventItem.link"
                  @click="modalOpen(idx)"
                  class="profile-activity__event-status"
                  :class="eventItem.status"
                  v-html="eventItem.statusName"
                />
                <modal :show.sync="showModal" :alignCenter="true">
                  <div>{{ popupText }}</div>
                </modal>
              </div>
          </div>
        </vue-scrollbar>-->
      </div>
    </div>
  </my-modal>
</template>

<script>

import Doughnut from '../ui/charts/doughnut'
// import Modal from "../ui/Modal";
// import VueScrollbar from 'vue2-scrollbar';
import api from "../../services/api";

export default {
  name: "ProfileActivity",
  components: {
    // Modal,
    // VueScrollbar,
    Doughnut,
  },
  data() {
    return {
      stats: {
        materialsCnt: 7,
        finishesCnt: 7,
      },
      showModal: false,
      popupText: '',
      options: {
        percentFill: 0, // Процент заполнения
        responsive: true,
        maintainAspectRatio: false,
        size: 170,
        cutoutPercentage : 80,
        scales:{
          xAxes: [{
            display: false,
            gridLines: {
              display: false,
            },
          }],
          yAxes: [{
            display: false,
            gridLines: {
              display: false,
            }
          }]
        },
        rotation: (0.5 * Math.PI),
        tooltips: {
          enabled: false,
        },
      },
    }
  },
  props: {
    events: {
      type: Array,
      default: () => [
        {
          name: 'Статья «Новый образ жизни»: Правда или миф?',
          statusName: 'Можно пройти',
          status: 'possible',
          link: '',
        },
        {
          name: 'Тест «Путешествия»: Нонограмма',
          statusName: 'Успешно',
          status: 'success',
          link: '',
        },
        {
          name: 'Статья «Кухня народов мира»: Правда или миф?',
          statusName: 'Успешно',
          status: 'success',
          link: '',
        },
        {
          name: 'Статья «Технологии и наука»: Правда или миф?',
          statusName: 'Завершен',
          status: 'completed',
          link: '',
        },
        {
          name: 'Статья «Технологии и наука»: Правда или миф?',
          statusName: 'Завершен',
          status: 'completed',
          link: '',
        },
        {
          name: 'Статья «Технологии и наука»: Правда или миф?',
          statusName: 'Завершен',
          status: 'completed',
          link: '',
        },
        {
          name: 'Статья «Технологии и наука»: Правда или миф?',
          statusName: 'Завершен',
          status: 'completed',
          link: '',
        },
      ]
    }
  },
  computed: {
    profileData() {
      return this.$store.state.profileData;
    },
    profileName() {
      return `${ this.profileData.firstName } ${ this.profileData.lastName } ${ this.profileData.middleName }`
    },
  },
  methods: {
    modalOpen(idx) {
      if (this.events[idx].status === 'success') {
        this.showModal = true;
        this.popupText = this.events[idx].name;
      }
    },
    async getStats() {
      this.stats = await api.getFinishStats();
      this.options.percentFill =
        parseInt(this.stats.finishesCnt) === 0
          ? 0
          : parseInt((parseInt(this.stats.finishesCnt)/parseInt(this.stats.materialsCnt)) * 100);
    },
  },
  created() {
    this.getStats();
  },
}
</script>

<style lang="scss">
@import "../../scss/base/_settings.scss";
@import "../../scss/blocks/scrollbar";

$b: '.profile-activity';

#{$b} {
  position: relative;

  h2 {
    text-align: center;
    font-weight: 400;
    font-size: 26px;
    line-height: 34px;
    text-transform: uppercase;
    margin: 0 0 50px;
  }

  &__info {
    display: flex;

    @include mobile {
      flex-direction: column-reverse;
      justify-content: center;
    }

    &-person {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 120%;
      margin-bottom: 10px;
    }
  }

  &__chart {
    position: relative;

    &-percent {
      position: absolute;
      right: 15px;
      top: 15px;
      color: $blue;
      border: 1px solid $blue;
      background-color: $white-true;
      border-radius: 3px;
      font-size: 18px;
      font-weight: 600;
      line-height: 22px;
      padding: 0 6px 2px;
      z-index: 10;

      @include mobile {
        width: max-content;
        left: calc(50% + 40px);
        transform: translateX(-50%);
      }
    }

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      background-position: center;
      width: 60px;
      height: 74px;
      background-repeat: no-repeat;
    }

    &.male:before {
      background-image: url("data:image/svg+xml,%0A%3Csvg width='60' height='74' viewBox='0 0 60 74' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.3347 20.8235H13.1832C9.91954 20.8235 7.2747 23.4796 7.2747 26.7557V27.06C7.2747 30.3368 9.92019 32.9922 13.1832 32.9922H14.4406C15.251 35.1263 16.4951 37.0872 18.1406 38.7393C19.8058 40.4112 21.786 41.692 23.9401 42.5242V45.9271C23.9401 46.3091 23.6313 46.6192 23.2509 46.6192H14.8813C8.04058 46.6192 2.26975 51.7334 1.42125 58.5499C0.907622 62.6766 0.362309 67.0504 0.0287696 69.7256C-0.104391 70.8072 0.228515 71.8965 0.948221 72.7133C1.66793 73.5314 2.7009 74 3.78769 74H56.2121C57.2983 74 58.332 73.5314 59.0516 72.7133C59.7713 71.8965 60.1048 70.8073 59.971 69.7256C59.6375 67.0497 59.0922 62.6766 58.5785 58.5499C57.7301 51.7334 51.9592 46.6192 45.1185 46.6192H36.7293C36.3488 46.6192 36.04 46.3091 36.04 45.9271V42.4739C38.1446 41.6405 40.078 40.3774 41.7095 38.7393C43.3531 37.0891 44.6398 35.1263 45.4894 32.9922H46.8908C50.1544 32.9922 52.7992 30.3361 52.7992 27.06V26.7557C52.7992 23.479 50.1537 20.8235 46.8908 20.8235H46.665V12.3765C46.665 9.09975 45.2909 5.93873 42.9834 3.62194C40.6728 1.30206 37.5416 0 34.2747 0H33.2246C29.9584 0 26.8246 1.30195 24.516 3.62194C24.1691 3.96891 23.8463 4.33562 23.5464 4.71889C23.036 4.61575 22.5116 4.56355 21.9827 4.56355H21.2751C19.1477 4.56355 17.1103 5.41092 15.6055 6.92108C14.0964 8.4363 13.3329 10.38 13.3329 12.5236V20.8229L13.3347 20.8235ZM48.1496 50.1064V70.9583H56.2128C56.4297 70.9583 56.6371 70.8641 56.781 70.7011C56.9249 70.5368 56.9915 70.3191 56.9643 70.1033L55.5737 58.9276C55.0448 54.6805 52.0557 51.2841 48.1497 50.1063L48.1496 50.1064ZM14.8817 49.662V70.9589H45.1189V49.662H41.8463C41.372 51.8101 40.2979 53.7984 38.7241 55.3785C36.5485 57.5616 33.5987 58.789 30.5232 58.789H29.4776C26.4022 58.789 23.4524 57.5616 21.2767 55.3785C19.7022 53.7977 18.6281 51.81 18.1544 49.662H14.8817ZM11.8514 50.1064C7.94538 51.2836 4.95608 54.6807 4.42737 58.9278L3.03679 70.1035C3.00952 70.3193 3.0761 70.537 3.22004 70.7013C3.36398 70.8643 3.57134 70.9585 3.78819 70.9585H11.8514L11.8514 50.1064ZM33.011 43.3523C32.0003 43.5439 30.9686 43.6413 29.9261 43.6413C28.9274 43.6413 27.9382 43.5516 26.9699 43.3765V45.9275C26.9699 47.9902 25.3048 49.662 23.2503 49.662H21.2853C21.6911 50.9946 22.4185 52.222 23.4185 53.226C25.0259 54.8399 27.2047 55.7465 29.4773 55.7465H30.5229C32.7955 55.7465 34.9743 54.8399 36.5817 53.226C37.5817 52.222 38.3091 50.9946 38.7149 49.662H36.7301C34.6756 49.662 33.0105 47.9902 33.0105 45.9275V43.3522L33.011 43.3523ZM22.3614 18.4585C24.9035 20.9058 28.8337 23.8662 33.788 23.8662H43.6362V26.9088C43.6362 30.5415 42.1258 34.0221 39.5684 36.5895C37.011 39.157 33.5432 40.5992 29.9263 40.5992C26.3101 40.5992 22.8403 39.1572 20.2842 36.5895C17.7269 34.0232 16.3648 30.5382 16.3648 26.9088V23.264L20.3995 21.1356C21.4388 20.5881 22.1541 19.593 22.3614 18.4585ZM46.667 23.8662V26.9088C46.667 27.9357 46.5688 28.955 46.3792 29.9513H46.8928C48.4838 29.9513 49.7715 28.657 49.7715 27.061V26.7567C49.7715 25.1612 48.4837 23.8663 46.8928 23.8663L46.667 23.8662ZM13.3359 23.8662H13.1843C11.5953 23.8662 10.3056 25.1605 10.3056 26.7565V27.0609C10.3056 28.6563 11.5947 29.9512 13.1843 29.9512H13.6022C13.4246 28.9548 13.3352 27.9375 13.3352 26.9086V23.8661L13.3359 23.8662ZM43.638 20.8237V12.3767C43.638 9.90326 42.5866 7.52291 40.8441 5.7733C39.1017 4.02565 36.7396 3.0427 34.278 3.0427H33.228C30.7644 3.0427 28.4024 4.02568 26.6619 5.7733C26.1983 6.23869 25.7894 6.74674 25.4374 7.2917C25.0557 7.88188 24.3195 8.13272 23.6588 7.89715C23.1268 7.70678 22.5618 7.60684 21.986 7.60684H21.2783C19.9556 7.60684 18.6874 8.13463 17.7527 9.07304C16.8237 10.0057 16.3665 11.2058 16.3665 12.5243V19.8274L18.9924 18.4433C19.2409 18.3109 19.3969 18.0524 19.3969 17.7697V14.7393C19.3969 14.1173 19.7742 13.557 20.35 13.3278C20.9245 13.0967 21.582 13.2393 22.0088 13.6901C23.5212 15.2855 27.6675 20.8243 33.7897 20.8243H43.638V20.8237Z' fill='%231E418E' fill-opacity='0.5'/%3E%3C/svg%3E%0A");
    }

    &.female:before {
      background-image: url("data:image/svg+xml,%0A%3Csvg width='60' height='74' viewBox='0 0 60 74' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M23.1824 46.5357H14.8813C8.04058 46.5357 2.26975 51.6655 1.42125 58.5028C0.907625 62.644 0.362308 67.0292 0.0287694 69.7125C-0.104391 70.7975 0.228518 71.89 0.948223 72.7107C1.66793 73.53 2.7009 74 3.78769 74H56.2121C57.2983 74 58.332 73.53 59.0516 72.7107C59.7713 71.8901 60.1048 70.7975 59.971 69.7125C59.6375 67.0285 59.0922 62.6434 58.5786 58.5028C57.7301 51.6655 51.9592 46.5357 45.1185 46.5357H36.8174C36.6158 46.5357 36.4237 46.4546 36.281 46.3129C36.1402 46.1692 36.0597 45.9757 36.0597 45.7726V42.3352C37.3019 41.8467 38.485 41.2094 39.5821 40.4328H51.2102C51.7086 40.4328 52.1741 40.1857 52.4569 39.7738C52.7403 39.36 52.8037 38.8338 52.6268 38.3657L50.1557 31.8158C51.7498 30.7494 52.7992 28.9261 52.7992 26.8539V26.5487C52.7992 23.7076 50.8233 21.3321 48.1798 20.7401V18.3844C48.1798 13.5095 46.2572 8.83304 42.833 5.38464C39.4088 1.93623 34.7654 0 29.9245 0H28.558C23.7173 0 19.0737 1.93623 15.6496 5.38464C12.2254 8.83304 10.3027 13.5093 10.3027 18.3844V21.3507C8.49552 22.3686 7.27236 24.3151 7.27236 26.5488V26.8541C7.27236 28.6804 8.09036 30.3159 9.37697 31.4073L7.33324 38.4821C7.20008 38.9431 7.28948 39.4406 7.57547 39.8231C7.86208 40.2075 8.31038 40.4336 8.78722 40.4336H20.4154C21.5124 41.2101 22.6956 41.8481 23.9378 42.336V45.7734C23.9378 45.9765 23.8573 46.17 23.7165 46.3137C23.5738 46.4555 23.3817 46.5366 23.18 46.5366L23.1824 46.5357ZM14.3906 49.5997C9.29555 49.8359 5.06669 53.7358 4.4276 58.8808L3.03702 70.0905C3.00975 70.3069 3.07633 70.5254 3.22027 70.6901C3.36421 70.8536 3.57157 70.9481 3.78842 70.9481H56.2128C56.4297 70.9481 56.6371 70.8536 56.781 70.6901C56.9249 70.5254 56.9915 70.3069 56.9642 70.0905L55.5737 58.8808C54.9345 53.7356 50.7057 49.8359 45.6107 49.5997C43.2519 55.3565 37.1658 59.5054 30.001 59.5054C22.8363 59.5054 16.7502 55.3565 14.3914 49.5997H14.3906ZM33.0309 43.2049C32.0386 43.3894 31.0253 43.4839 30.0006 43.4839C28.9765 43.4839 27.9625 43.3894 26.9702 43.2049V45.7726C26.9702 46.7841 26.572 47.7548 25.8611 48.47C25.1503 49.1859 24.1872 49.5869 23.1827 49.5869H17.7377C19.9601 53.6701 24.633 56.453 30.0006 56.453C35.3681 56.453 40.041 53.6701 42.2634 49.5869H36.8184C35.814 49.5869 34.8502 49.1859 34.14 48.47C33.4291 47.7542 33.0309 46.7842 33.0309 45.7726V43.2049ZM30.0006 40.4328C26.3843 40.4328 22.9157 38.9864 20.3585 36.4109C17.8011 33.8355 16.3648 30.3431 16.3648 26.7006V18.7541C16.3648 18.5102 16.486 18.281 16.6889 18.1456L16.6997 18.1379C18.477 16.945 20.6704 16.5587 22.7464 17.0759C28.5238 18.5543 33.6321 18.521 37.5761 16.9648V17.6577C37.5761 19.1028 38.3865 20.4241 39.6698 21.0696L43.6362 23.0672V26.7013C43.6362 30.3431 42.1999 33.8363 39.6425 36.4115C37.0852 38.987 33.6173 40.4334 30.0005 40.4334L30.0006 40.4328ZM10.8083 37.381H17.1461C16.0143 36.0004 15.1157 34.4531 14.4766 32.8036H12.5782L10.8083 37.381ZM47.2838 32.7915C47.1551 32.7992 45.5261 32.8036 45.5261 32.8036C44.8869 34.4531 43.9884 36.0005 42.8566 37.381H49.0155L47.2838 32.7915ZM13.3358 29.7518H13.1842C11.5952 29.7518 10.3055 28.4536 10.3055 26.8527V26.5474C10.3055 24.9471 11.5946 23.6483 13.1842 23.6483H13.3358V29.7518ZM46.667 23.6488H46.8927C48.4836 23.6488 49.7714 24.9471 49.7714 26.548V26.8532C49.7714 28.4535 48.4836 29.7523 46.8927 29.7523H46.667V23.6488ZM45.1521 20.4169V18.383C45.1521 14.3165 43.5478 10.4168 40.6931 7.54053C37.837 4.66561 33.9646 3.04996 29.9267 3.04996H28.5602C24.5222 3.04996 20.6499 4.66558 17.7938 7.54053C14.9391 10.4168 13.3348 14.3165 13.3348 18.383V18.7541C13.3348 17.489 13.9619 16.3083 15.0076 15.6065L15.0184 15.5988C17.5059 13.9295 20.5745 13.3912 23.4754 14.1128C23.4786 14.1141 23.4818 14.1141 23.4843 14.116C29.5082 15.6601 34.7021 15.4953 38.2792 13.2067C38.7459 12.9078 39.3369 12.8893 39.8214 13.1581C40.3046 13.4251 40.6064 13.9378 40.6064 14.4947V17.6577C40.6064 17.9463 40.7687 18.21 41.0242 18.3397L45.1516 20.4176L45.1521 20.4169Z' fill='%231E418E' fill-opacity='0.5'/%3E%3C/svg%3E");
    }
  }

  &__achievements {
    display: flex;
    flex-direction: column;
    margin: auto 0 auto 50px;

    @include mobile {
      margin: 0;
      align-items: center;
    }

      &-read,
      &-participation {
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        margin-bottom: 10px;
    }
  }

  &__events {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    padding-top: 30px;
    border-top: 1px solid #E8EBF1;
  }

  &__event {
    display: flex;
    flex-direction: row;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    align-items: center;

    @include mobile {
      flex-direction: column;
    }

    &:first-child {
      font-size: 14px;
      color: #7A8BB2 !important;
    }

    &:not(:last-child) {
      margin-bottom: 15px;

      @include mobile {
        border-bottom: 1px solid lightgray;
        padding-bottom: 15px;
      }
    }

    &-name {
      width: 75%;

      @include mobile {
        width: 100%;
        margin-bottom: 10px;
      }
    }

    &-status {
      color: $blue;
      padding: 4px 8px 6px;

      @include mobile {
        margin-left: auto;
      }

      &.possible {
        border: 1px solid $blue;
        border-radius: 3px;
        text-decoration: none;
        transition: all .2s ease-in;

        &:hover {
          color: #ffffff;
          background-color: $blue;
          border-color: $blue;
        }
      }

      &.success {
        cursor: pointer;
        color: $blue;
      }

      &.completed {
        color: $text-gray;
      }
    }
  }

  &__scrollbar {
    .profile-activity__event-name {
      color: #1e418e;
      font-size: 16px;
    }

    .profile-activity__event-status.possible {
      color: $blue;
      font-size: 16px;
    }
  }

  .vue-scrollbar__area {
    overflow: auto;
  }

  .my-scrollbar {
    max-height: 200px;
    margin: 0;

    @include tablet {
      max-height: none;
      height: inherit;
    }
  }

  .modal__wrapper {
    background: rgba(0, 0, 0, 0.3);
  }
}

</style>
